import React, { Component } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Carousel } from 'antd';
import lottie01 from '../../images/lottie01.json'
import { Link } from 'react-router-dom'
import theme from '../../config/theme'
import Lottie from 'lottie-react'

export default class Banner extends Component {
    constructor(props) {
        super (props)
        this.state = {
            dotPosition: 'bottom',
        }
    }

    componentDidMount = async () => {
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    render() {
        return (
            <Carousel autoplay autoplaySpeed={8000} pauseOnHover={false} pauseOnDotsHover={false} draggable className="slideHome">
                <div className="section slideHome">
                    <Container>
                        <Row>
                            <Col md={6} className="d-flex flex-column justify-content-center">
                                <h1 className="text-white text-uppercase textLeftMobileCenter768"><span style={{ color: theme.colors.primary }}> Up 365 </span> Um novo conceito no mercado de Investimentos !</h1>
                                <p className="text-white">A Inovação Que Você Precisa para Alcançar Seus Objetivos Financeiros.</p>
                                <Link 
                                    to="/cadastro" 
                                    className='anchorBtn mt-3 buttonCrypto'
                                    style={{
                                        backgroundColor: theme.colors.primary,
                                        color: theme.colors.white,
                                        borderColor: theme.colors.primary,
                                        fontFamily: theme.typography.fontFamily.bold,
                                        fontSize: theme.typography.fontSize.medium,
                                        textDecoration: 'none',
                                    }}
                                >
                                    INVESTIR AGORA
                                </Link>
                            </Col>
                            <Col md={6}>
                                <Lottie 
                                    animationData={lottie01}
                                    loop={true}
                                    className="img-fluid"
                                />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="section slideHome">
                    <Container>
                        <Row>
                            <Col md={6} className="d-flex flex-column justify-content-center">
                            <h1 className="text-white text-uppercase textLeftMobileCenter768"><span style={{ color: theme.colors.primary }}> Up 365 </span> Um novo conceito no mercado de Investimentos !</h1>
                            <p className="text-white">A Inovação Que Você Precisa para Alcançar Seus Objetivos Financeiros.</p>
                                <Link 
                                    to="/cadastro" 
                                    className='anchorBtn mt-3 buttonCrypto'
                                    style={{
                                        backgroundColor: theme.colors.primary,
                                        color: theme.colors.white,
                                        borderColor: theme.colors.primary,
                                        fontFamily: theme.typography.fontFamily.bold,
                                        fontSize: theme.typography.fontSize.medium,
                                        textDecoration: 'none',
                                    }}
                                >
                                    INVESTIR AGORA
                                </Link>
                            </Col>
                            <Col md={6}>
                                <Lottie 
                                    animationData={lottie01}
                                    loop={true}
                                    className="img-fluid"
                                />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Carousel>
        )
    }
}